import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'

const useTradeStore = create((set, get) => ({
  trades: {},
  trade_count: 0,
  fetchTrades: async () => {
    const token = Cookies.get('token')
    try {    
    const res = await axios({
      headers: { Authorization: token },
      method: "GET",
      url:"/api/trades_state",
      timeout : 2000
    })

    set({trades : await res.data})    
    } catch (err) {
      console.log(err)
    }
    get().countTrades()
  },
  updateTrade: (trade) => {

    get().fetchTrades()
    get().countTrades()
  },
  addTrade: (trade) => {


    get().fetchTrades()
    get().countTrades()
},
  removeTrade: (trade) => {
 
    get().fetchTrades()
    get().countTrades()
  },
  countTrades : () => {
    const trades = get().trades
    let count = 0
    for (const exchange in trades) {
      for (const instrument in trades[exchange]){
        for (const side in trades[exchange][instrument]) {
          for (const trade in trades[exchange][instrument][side]){
            count ++            
          }
        }
      }
    }
    set({trade_count : count})
  }
}))



export default useTradeStore 